import { Flex, TagFilledIcon, Typography } from '@iheartjane/reefer';

import { useHeadlessApp } from '@jane/shared/providers';

export const SpecialsTag = ({ title }: { title: string }) => {
  const {
    options: { theme },
  } = useHeadlessApp();
  const specialBadgeColor = theme?.specialBadgeColor;

  return (
    <Flex
      alignItems="center"
      style={
        specialBadgeColor
          ? { '--colors-info-main': specialBadgeColor }
          : undefined
      }
    >
      <TagFilledIcon size="sm" color="info" />
      <Typography color="info" ml={4}>
        {title}
      </Typography>
    </Flex>
  );
};
